import { useRecoilState } from "recoil";
import { modalState } from "../recoil/modal";
import { useCallback } from "react";

type OpenModalType = {
  type: "login" | "guide" | "";
  message: string;
};

export const useModal = () => {
  const [modalDataState, setModalDataState] = useRecoilState(modalState);

  const closeModal = useCallback(() => {
    setModalDataState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, [setModalDataState]);

  const openModal = useCallback(
    ({ type, message }: OpenModalType) => {
      setModalDataState({ type: type, message: message, isOpen: true });
    },
    [setModalDataState]
  );

  return { modalDataState, closeModal, openModal };
};
